module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"infinity\"-in-garden-grove-california-01ad00cef386f169f4af4346d857372a.png";